var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c(_vm.type,{tag:"component",staticClass:"custom-overlay",class:_vm.overlayClass,style:(_vm.overlayStyle)},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }